// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"77acc182","445":"00fca975","446":"9be2bc87","636":"97ea1302","965":"ba2b4257"}[chunkId] + ".chunk.js";
};